import React from 'react';
import { Grid, Col } from '@bit/knotchinc.web-react-components.grid';
import { ComponentTabContainer, ComponentTab } from '@bit/knotchinc.web-react-components.tabs';
import ContentCard from 'components/Global/Card/ContentCard.jsx';
import KeywordListCard from 'components/Pages/Reports/KeywordListCard.jsx';
import ErrorContentCard from 'components/Pages/Reports/ErrorStates/ErrorContentCard.jsx';
import ErrorStatsOverviewRow from 'components/Pages/Reports/ErrorStates/ErrorStatsOverviewRow.jsx';
import Box from '@bit/knotchinc.web-react-components.box';
import { StyledOverviewContainer } from './styled';

const EntityOverview = ({ data, Row, type, entityType }) => {
  if (data.length < 1) {
    return (
      <StyledOverviewContainer>
        <ComponentTabContainer>
          <ComponentTab tabName="--">
            <Grid height={450} gridStyle={{ borderColor: 'white' }}>
              <Col centered>
                <Box width="100%" p="0px 5px 0 19px">
                  <ErrorContentCard />
                </Box>
              </Col>
              <Col weight={2} centered>
                {type === 'keywords' ? (
                  <Box width="100%" p="0px 20px 0 8px">
                    <KeywordListCard title="TOP MENTIONED KEYWORDS" />
                  </Box>
                ) : (
                  <Box width="100%" p="0px 20px 0 7px">
                    <ErrorStatsOverviewRow type={type} entityType={entityType} />
                  </Box>
                )}
              </Col>
            </Grid>
          </ComponentTab>
        </ComponentTabContainer>
      </StyledOverviewContainer>
    );
  }

  return (
    <StyledOverviewContainer>
      <ComponentTabContainer>
        {data.map(({ entity, resources, top_content }) => (
          <ComponentTab key={`tab-${entity.name}`} tabName={entity.name} tabIcon={entity.logo_url}>
            <Grid height={469} gridStyle={{ borderColor: 'white' }}>
              <Col>
                <Box width="100%" p="45px 5px 0 19px">
                  {top_content && top_content.public_id ? (
                    <ContentCard data={top_content} width="100%" height="386px" />
                  ) : (
                    <ErrorContentCard />
                  )}
                </Box>
              </Col>
              <Col weight={2}>
                {type === 'keywords' ? (
                  <Box width="100%" p="53px 20px 0 8px">
                    <KeywordListCard resources={resources} title="TOP MENTIONED KEYWORDS" />
                  </Box>
                ) : (
                  <Box width="100%" p="53px 20px 0 7px">
                    {resources.length > 0
                      ? resources.map((itemData, idx) => <Row key={`overview-row-${idx}`} data={itemData} />)
                      : null}
                    {/* Error state for Social & Brand/Publisher Overview rows */}
                    {resources.length < 1 ? <ErrorStatsOverviewRow type={type} entityType={entity.type} /> : null}
                  </Box>
                )}
              </Col>
            </Grid>
          </ComponentTab>
        ))}
      </ComponentTabContainer>
    </StyledOverviewContainer>
  );
};

export default EntityOverview;
